import React, { useEffect } from "react";
import { Outlet, useLocation, ScrollRestoration } from "react-router-dom";
import Header from "./Header";

export default function Layout() {
  const location = useLocation();

  useEffect(() => {
    // Scroll to top for all portfolio pages
    if (location.pathname.startsWith("/portfolio/")) {
      window.scrollTo(0, 0);
    }
    // Home page will naturally restore scroll position via ScrollRestoration component
  }, [location.pathname]);

  return (
    <>
      <ScrollRestoration 
        getKey={(location) => {
          // Use pathname as key for home page to remember scroll position
          // Use a constant key for portfolio pages so they always reset
          return location.pathname.startsWith("/portfolio/") 
            ? "portfolio" 
            : location.pathname;
        }}
      />
      <Header />
      <Outlet />
    </>
  );
}
